<section class="bg-gradient-to-r from-black to-neutral-900 flex  justify-center w-full   text-white pb-4  ">


  <div class="flex flex-col items-center  w-full max-w-4xl">
    <div class="flex flex-row w-full justify-between max-lg:flex-col max-lg:p-4">
      <div class="  md:my-12 my-4  max-sm:w-full">
        <h2 class=" text-xl font-semibold md:mb-4 max-sm:mb-2 max-sm:text-2xl text-primary">Links</h2>
        <ul class=" text-base">
          <li class="mb-2"><a [routerLink]="['/']">Home</a></li>
          <li class="mb-2"><a [routerLink]="['/product-overview']">Packages</a></li>
          <li class="mb-2"><a [routerLink]="['/blogs']">Blogs</a></li>
          <li class="mb-2"><a [routerLink]="['/about-us']">About Us</a></li>
          <li class="mb-2"><a [routerLink]="['/contact-us']">Contact Us</a></li>
        </ul>
      </div>


      <div class=" md:my-12 my-4 max-sm:w-full">
        <h2 class=" text-xl font-semibold md:mb-4 max-sm:mb-2 max-sm:text-2xl text-primary">Customers</h2>
        <ul class=" text-base">
          <li class="mb-2"><a routerLink="/sign-in">Account Login</a></li>
          <li class="mb-2"><a routerLink="/sign-up">Account Registration</a></li>
        </ul>
      </div>

      <!-- New Legal Links Section -->
      <div class=" md:my-12 my-4 max-sm:w-full">
        <h2 class=" text-xl font-semibold md:mb-4 max-sm:mb-2 max-sm:text-2xl text-primary">Legal</h2>
        <ul class=" text-base">
          <li class="mb-2"><a href="assets/privacy-policy.pdf" target="_blank" rel="noopener noreferrer">Privacy
              Policy</a></li>
          <li class="mb-2"><a href="assets/disclaimer.pdf" target="_blank" rel="noopener noreferrer">Disclaimer</a></li>
          <li class="mb-2"><a href="assets/terms-of-use.pdf" target="_blank" rel="noopener noreferrer">Terms of Use</a>
          </li>
        </ul>
      </div>


      <div class=" md:my-12 my-4 max-sm:w-full">
        <h2 class=" text-xl font-semibold md:mb-4 max-sm:mb-2 max-sm:text-2xl text-primary">Contact Us</h2>
        <ul class=" text-base">
          <li class="mb-2 text-white">
            Call Centre:
            <a href="tel:0110659526" class="underline hover:text-blue-600 transition">
              Call Now
            </a>
          </li>
          <li class="w-full">
            <div class="flex flex-row pt-1">
              <div class="mr-5 cursor-pointer">
                <a target="_blank" rel="noopener" aria-label="Facebook Icon"
                  href="https://www.facebook.com/KayaKonekta"><svg stroke="currentColor" fill="currentColor"
                    stroke-width="0" viewBox="0 0 512 512" color="#3E2D79" height="28" width="28"
                    xmlns="http://www.w3.org/2000/svg" style="color: #F8FAFC;">
                    <path
                      d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z">
                    </path>
                  </svg></a>
              </div>
              <div class="mr-5 cursor-pointer">
                <a target="_blank" rel="noopener" aria-label="Instagram Icon"
                  href="https://www.instagram.com/kayakonekta/"><svg stroke="currentColor" fill="currentColor"
                    stroke-width="0" role="img" viewBox="0 0 24 24" color="#3E2D79" height="28" width="28"
                    xmlns="http://www.w3.org/2000/svg" style="color: #F8FAFC;">
                    <title></title>
                    <path
                      d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z">
                    </path>
                  </svg></a>
              </div>
              <div class="mr-5 cursor-pointer">
                <a target="_blank" rel="noopener" aria-label="X Icon" href="https://twitter.com/KKonekta"><svg
                    stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" color="#3E2D79"
                    height="28" width="28" xmlns="http://www.w3.org/2000/svg" style="color: #F8FAFC;">
                    <path
                      d="M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z">
                    </path>
                  </svg></a>
              </div>
              <div class="mr-5 cursor-pointer">
                <a target="_blank" rel="noopener" aria-label="TikTok Icon" href="https://www.tiktok.com/@kako.africa">
                  <svg fill="currentColor" viewBox="0 0 24 24" height="28" width="28" xmlns="http://www.w3.org/2000/svg"
                    style="color: #F8FAFC;">
                    <path
                      d="M12.43 0h3.22a5.78 5.78 0 0 0 5.74 5.1v3.18a8.91 8.91 0 0 1-5.64-1.96v8.61a6.97 6.97 0 1 1-6.94-6.95 7.15 7.15 0 0 1 1.32.13v3.27a3.78 3.78 0 1 0 2.3 3.45V0Z" />
                  </svg>
                </a>
              </div>

            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- Address / Email / Phone -->
    <div class="  flex flex-wrap justify-start gap-12 items-start text-left text-lg mt-8">
      <!-- Location CTA Button -->
      <div class="flex items-start gap-2 group">
        <span class="material-icons text-primary">location_on</span>
        <a href="https://maps.google.com/?q={{ companyInfoHeader?.address }}" 
           target="_blank" 
           rel="noopener noreferrer"
           class="text-white hover:text-primary transition-colors duration-200 cursor-pointer  underline underline-offset-2 hover:underline-offset-4  hover:decoration-primary">
          {{ companyInfoHeader?.address }}
        </a>
      </div>

      <!-- Email CTA Button -->
      <div class="flex items-start gap-2 group">
        <span class="material-icons text-primary">mail</span>
        <a href="mailto:{{ companyInfoHeader?.email }}"
           class="text-white hover:text-primary transition-colors duration-200 cursor-pointer underline underline-offset-2 hover:underline-offset-4 hover:decoration-primary">
          {{ companyInfoHeader?.email }}
        </a>
      </div>

      <!-- Phone CTA Button -->
      <div class="flex items-start gap-2 group">
        <span class="material-icons text-primary">call</span>
        <a href="tel:{{ companyInfoHeader?.phone }}"
           class="text-white hover:text-primary transition-colors duration-200 cursor-pointer underline underline-offset-2 hover:underline-offset-4  hover:decoration-primary">
          {{ companyInfoHeader?.phone }}
        </a>
      </div>
    </div>
  </div>
</section>